import type React from 'react';

import type { ColorName } from 'styles/config/colors';

import { InfoIcon } from '../Icons';
import Tooltip from '../Tooltip';
import * as Styled from './LegacyTag.styled';

export enum LegacyTagVariant {
  DEFAULT = 'DEFAULT',
  ACTIVE = 'ACTIVE',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  KEYWORD = 'KEYWORD',
  INFO = 'INFO',
  GRAY = 'GRAY',
  WARNING = 'WARNING',
}

export interface LegacyTagProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  append?: React.ReactNode;
  prepend?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  textColor?: ColorName;
  variant?: LegacyTagVariant;
  iconOnly?: boolean;
  infoContent?: React.ReactNode;
  hideBorder?: boolean;
  textDataTestId?: string;
}

/**
 * @deprecated Use `Tag` from `components/atoms/Tag` instead.
 */
const LegacyTag: React.FC<LegacyTagProps> = ({
  append,
  prepend,
  onClick,
  children,
  textColor,
  variant = LegacyTagVariant.DEFAULT,
  iconOnly,
  infoContent,
  hideBorder,
  textDataTestId = 'tag-text',
  ...props
}) => {
  return (
    <Styled.TagWrapper
      $hideBorder={hideBorder}
      $iconOnly={iconOnly}
      append={!!append}
      clickable={!!onClick}
      variant={variant}
      onClick={onClick}
      {...props}
    >
      {prepend}
      <Styled.TagText $color={textColor} data-test-id={textDataTestId}>
        {children}
      </Styled.TagText>
      {append}
      {variant === LegacyTagVariant.INFO && infoContent && (
        <Tooltip content={infoContent} placement="top" complex={true}>
          <InfoIcon color="iconInfo" />
        </Tooltip>
      )}
    </Styled.TagWrapper>
  );
};

export { LegacyTag };
